import { c as _c } from "react/compiler-runtime";
import { TransformationIssueWithData } from '../../../../../../../typings/Issue.interface';
import { TransformationExecution } from '../../../../../../../typings/TransformationExecution.interface';
import TransformationExecutionsList from '../Transformation/TransformationExecutionsList';
import { StyledCard } from '../../../common/base/Card';
import useSearchQuery from '../../../hooks/useSearchQuery';
import { TransformationExecutionsQueryProps } from '../../../../typings/TransformationExecution.interface';
import { extractFiltersFromQuery } from '../Transformation/TransformationExecutionsView';
import { extractFromArray } from '../../../../utils';
import styled, { css } from 'styled-components';
import Filters from '../../../common/Filters/Filters';
import { transformation_issue_fatal_execution_list_filters } from '../../../common/Filters/FilterComponents';
import { Div } from '../../../common/helpers/StyledUtils';
import Divider from '../../../common/base/Divider';
interface IssueTransformationExecutionsProps {
  issue: TransformationIssueWithData;
  fatal_executions: number;
  mutateFatalExecutions: () => void;
  onEdit: (execution?: TransformationExecution) => void;
}
export const StyledViewContainerCard = styled(StyledCard)<{
  border_top?: boolean;
}>(({
  theme,
  border_top
}) => css`
    background-color: ${theme.colors.surface.base.surface};
    border: none;
    border-radius: 0;
    border-bottom: ${theme.border};
    ${border_top && css`
      border-top: ${theme.border};
    `}
  `);
export const IssueTransformationExecutions = t0 => {
  const $ = _c(30);
  const {
    issue,
    onEdit
  } = t0;
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  let t1;
  if ($[0] !== query.selected_execution_id) {
    t1 = extractFromArray(query.selected_execution_id);
    $[0] = query.selected_execution_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selected_execution_id = t1 as string;
  let t2;
  if ($[2] !== query) {
    t2 = extractFiltersFromQuery(query);
    $[2] = query;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const base_filters = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["fatal"];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== base_filters || $[6] !== issue.id) {
    t4 = {
      ...base_filters,
      issue_id: issue.id,
      log_level: t3
    };
    $[5] = base_filters;
    $[6] = issue.id;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const filters = t4;
  let t5;
  if ($[8] !== updateSearchQuery) {
    t5 = new_filters => {
      updateSearchQuery(new_filters, {
        remove_keys: ["selected_execution_id", "next", "prev"],
        replace: true
      });
    };
    $[8] = updateSearchQuery;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const onFilterChanged = t5;
  let t6;
  if ($[10] !== updateSearchQuery) {
    t6 = selected_execution_id_0 => updateSearchQuery({
      selected_execution_id: selected_execution_id_0
    });
    $[10] = updateSearchQuery;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const onExecutionSelected = t6;
  let t7;
  if ($[12] !== updateSearchQuery) {
    t7 = pagination => {
      updateSearchQuery({
        prev: undefined,
        next: undefined,
        ...pagination
      }, {
        remove_keys: ["selected_execution_id"]
      });
    };
    $[12] = updateSearchQuery;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const onPaginationChanged = t7;
  let t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      align: "flex-start",
      gap: 3
    };
    t9 = {
      x: 6,
      y: 3
    };
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  let t10;
  if ($[16] !== filters || $[17] !== onFilterChanged) {
    t10 = <Div flex={t8} p={t9}><Filters route="transformation-executions" filters={filters} components={transformation_issue_fatal_execution_list_filters} onFilterChanged={onFilterChanged} /></Div>;
    $[16] = filters;
    $[17] = onFilterChanged;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Divider />;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== filters || $[21] !== issue.aggregation_keys.transformation_id[0] || $[22] !== onEdit || $[23] !== onExecutionSelected || $[24] !== onPaginationChanged || $[25] !== selected_execution_id) {
    t12 = <TransformationExecutionsList transformation_id={issue.aggregation_keys.transformation_id[0]} selected_execution_id={selected_execution_id} filters={filters} onPaginationChanged={onPaginationChanged} onExecutionSelected={onExecutionSelected} onEdit={onEdit} />;
    $[20] = filters;
    $[21] = issue.aggregation_keys.transformation_id[0];
    $[22] = onEdit;
    $[23] = onExecutionSelected;
    $[24] = onPaginationChanged;
    $[25] = selected_execution_id;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t12) {
    t13 = <>{t10}{t11}{t12}</>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};